import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/customer';

export type Quotations = Awaited<ReturnType<(typeof service)['getQuotations']>>;

export function getQuotationsOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Quotations>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['customers', 'quotations', guid, [search]],
    queryFn: async () => await service.getQuotations(guid, search),
    initialData,
  });
}
